import debounce from "lodash.debounce";
import { useMemo, useState } from "react";

import { AsyncCombobox } from "@sorcery/ui";

import { useRouter } from "next/navigation";
import { cardPath, deckPath, userPath } from "~/utils/paths";
import { api } from "~/utils/trpc";

export const SearchAllBox = () => {
  const { push } = useRouter();
  const [query, setQuery] = useState("");
  const { data, isFetching, isRefetching } = api.search.all.useQuery(
    {
      query,
    },
    {
      enabled: !!query,
    },
  );

  const debouncedChangeHandler = useMemo(() => debounce(setQuery, 500), []);

  const typeToPath = (type: "card" | "deck" | "user", idOrSlug: string) => {
    switch (type) {
      case "card":
        return cardPath(idOrSlug);
      case "deck":
        return deckPath(idOrSlug);
      case "user":
        return userPath(idOrSlug);
    }
  };

  return (
    <AsyncCombobox
      autoFocus
      placeholder="Search everything..."
      loading={isFetching && !isRefetching}
      onSelect={(o) => {
        push(typeToPath(o.type as "card" | "deck" | "user", o.value as string));
      }}
      query={query}
      setQuery={debouncedChangeHandler}
      options={data ?? []}
      highlightType={true}
    />
  );
};
